import { AuthContext } from '@monofront/types';
import { FRESH_USER, ULTRA_FRESH_USER } from '../constants';

export const isAuthContextMatching = (
  authContext: AuthContext | null = null,
  isAuthenticated: boolean,
  isMember: boolean,
): boolean => {
  switch (authContext) {
    case AuthContext.AUTH_ONLY:
      return isAuthenticated;
    case AuthContext.ANON_ONLY:
      return !isAuthenticated;
    case AuthContext.MEMBER_ONLY:
      return isMember || false;
    case AuthContext.NOT_MEMBER_ONLY:
      return typeof isMember === 'undefined' ? true : !isMember;
    default:
      return true;
  }
};

export const getIsFreshUser = (tags: string[]) =>
  tags && tags.some((tag) => tag === FRESH_USER);

export const getIsUltraFreshUser = (tags: string[]) =>
  tags && tags.some((tag) => tag === ULTRA_FRESH_USER);

export const isAuthContextMaching = isAuthContextMatching;
